import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Field } from 'redux-form';
import classNames from 'classnames';
import TextButton from '../../../../../elements-buttons/text-button';
import AddOnField from '../../fields/AddOnField/AddOnField';
import SelectField from '../../fields/SelectField/SelectField';
import TextField from '../../fields/TextField/TextField';
import currencyMap from 'currency-symbol-map';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class VatAddFees extends Component {
  constructor (props) {
    super(props);

    this.handleAddClick = this.handleAddClick.bind(this);
  }

  componentDidMount () {
    if (!this.props.addAddtlFees && 0 >= this.props.fields.length) {
      this.handleAddClick();
    }
  }

  handleAddClick (e) {
    if (e) { e.preventDefault(); }

    this.props.fields.push({
      charge_type: 'fee',
      charge_unit: '%'
    });
  }

  render () {
    const { fields, classnames, addOnFeeValues, addAddtlFees, currency } = this.props;
    const selectOptions = [
      { value: '%', label: '%' },
      { value: currencyMap(currency), label: currencyMap(currency) }
    ];
    const fees = addOnFeeValues;

    return (
      <div
        className={classNames('add-fees-component', classnames)}
        data-testing-id="vat-add-fees-component"
      >
        {
          fields.map((item, index) => {
            const fee = get(fees, index, {});
            const feeLabel = get(fee, 'charge_unit', '%');
            const leftLabel = '%' !== feeLabel;

            return (
              <div key={item.charge_id} className="fee-block">
                <div className="flex space-between margin-sm-bottom">
                  <label className="label text-gray-dark" htmlFor="count">
                    <FormattedMessage
                      id="inbox.create_item_form.fee_item_label"
                      defaultMessage="Fee item {feeItemCount}"
                      values={{ feeItemCount: index + 1 }}
                    />
                  </label>
                  <TextButton
                    id="remove-button"
                    onClick={(e) => { e.preventDefault(); fields.remove(index); }}
                    buttonText={ this.props.intl.formatMessage({ id: 'inbox.add_fees.remove', defaultMessage: 'Remove' }) }
                    classNames="underline no-padding"
                  />
                </div>

                <Field
                  name={`${item}.label`}
                  component={TextField}
                  className="margin-md-bottom"
                  errorMessage={ this.props.intl.formatMessage({ id: 'inbox.add_fees.enter_title', defaultMessage: 'Please enter a title' }) }
                  placeholder={ this.props.intl.formatMessage({ id: 'inbox.add_fees.fee_name', defaultMessage: 'Fee name, ie. Gratuity, delivery, service etc' }) }
                  attributes={{ 'data-testing-id': 'fee-label-field' }}
                />
                <div>
                  <div className="flex space-between">
                    <Field
                      name={`${item}.charge_unit`}
                      component={SelectField}
                      options={selectOptions}
                      errorMessage={ this.props.intl.formatMessage({ id: 'inbox.add_fees.selection', defaultMessage: 'Please make a selection' }) }
                      className="fee-unit margin-md-right"
                      id="fee-charge-unit-field"
                    />
                    <Field
                      name={`${item}.amount`}
                      component={AddOnField}
                      label={feeLabel}
                      leftLabel={leftLabel}
                      className="fee-field"
                      attributes={{ 'data-testing-id': 'fee-amount-field' }}
                    />
                  </div>
                  { addAddtlFees &&
                    <div className="flex space-between margin-md-top">
                      <div>
                        {
                          (index === fields.length - 1) &&
                          <TextButton
                            onClick={this.handleAddClick}
                            buttonText={ this.props.intl.formatMessage({ id: 'inbox.add_fees.add_more', defaultMessage: 'Add more' }) }
                            attributes={{ 'data-testing-id': 'add-more-fees-button' }}
                            classNames="underline no-padding"
                          />
                        }
                      </div>
                    </div> }
                </div>
              </div>
            );
          })
        }

        {
          0 >= fields.length && addAddtlFees &&
          <TextButton
            id="add-fee-button"
            onClick={this.handleAddClick}
            buttonText={ this.props.intl.formatMessage({ id: 'inbox.add_fees.text_only_add_fee', defaultMessage: 'Add a fee' }) }
            classNames="underline no-padding"
          />
        }
      </div>
    );
  }
}


VatAddFees.propTypes = {
  fields: PropTypes.object,
  classnames: PropTypes.string,
  addOnFeeValues: PropTypes.array,
  addAddtlFees: PropTypes.bool,
  currency: PropTypes.string,
  intl: intlShape
};

export default injectIntl(VatAddFees);
